/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orgs_HeadingInputs */

const th_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`องค์กร`)
};

const en_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisations`)
};

const ja_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`団体`)
};

const zh_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织`)
};

const es_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizaciones`)
};

const pt_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizações`)
};

const id_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisasi`)
};

const fr_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisations`)
};

const tl_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga organisasyon`)
};

const vi_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổ chức`)
};

const ko_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`조직`)
};

const de_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisationen`)
};

const ru_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Организации`)
};

const tr_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuruluşlar`)
};

const it_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizzazioni`)
};

const pl_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizacje`)
};

const uk_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Організації`)
};

const hi_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संगठन`)
};

const ar_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المؤسسات`)
};

const ms_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisasi`)
};

const bn_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংস্থা`)
};

const zh_tw2_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組織`)
};

const zh_hk2_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組織`)
};

const ur_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ادارے`)
};

const fa_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سازمان‌ها`)
};

const sw_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mashirika`)
};

const nl_orgs_heading = /** @type {(inputs: Orgs_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisaties`)
};

/**
* | output |
* | --- |
* | "Organisations" |
*
* @param {Orgs_HeadingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const orgs_heading = /** @type {((inputs?: Orgs_HeadingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orgs_HeadingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_orgs_heading(inputs)
	if (locale === "ja") return ja_orgs_heading(inputs)
	if (locale === "zh") return zh_orgs_heading(inputs)
	if (locale === "es") return es_orgs_heading(inputs)
	if (locale === "pt") return pt_orgs_heading(inputs)
	if (locale === "id") return id_orgs_heading(inputs)
	if (locale === "fr") return fr_orgs_heading(inputs)
	if (locale === "tl") return tl_orgs_heading(inputs)
	if (locale === "vi") return vi_orgs_heading(inputs)
	if (locale === "ko") return ko_orgs_heading(inputs)
	if (locale === "de") return de_orgs_heading(inputs)
	if (locale === "ru") return ru_orgs_heading(inputs)
	if (locale === "tr") return tr_orgs_heading(inputs)
	if (locale === "it") return it_orgs_heading(inputs)
	if (locale === "pl") return pl_orgs_heading(inputs)
	if (locale === "uk") return uk_orgs_heading(inputs)
	if (locale === "hi") return hi_orgs_heading(inputs)
	if (locale === "ar") return ar_orgs_heading(inputs)
	if (locale === "ms") return ms_orgs_heading(inputs)
	if (locale === "bn") return bn_orgs_heading(inputs)
	if (locale === "zh-TW") return zh_tw2_orgs_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_orgs_heading(inputs)
	if (locale === "ur") return ur_orgs_heading(inputs)
	if (locale === "fa") return fa_orgs_heading(inputs)
	if (locale === "sw") return sw_orgs_heading(inputs)
	if (locale === "nl") return nl_orgs_heading(inputs)
	return en_orgs_heading(inputs)
});